import { CheckOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { FC } from 'react'
import { useAcceptReceiptMutation } from '../../../../../../../store/api/receipts-api'
import useErrorModal from '../../../../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../../../../hooks/api/use-success-modal'

interface AcceptProps {
    documentId: string
}

const Accept: FC<AcceptProps> = ({ documentId }) => {
    const [accept, acceptState] = useAcceptReceiptMutation()

    const onClick = async () => {
        accept(documentId)
    }

    useErrorModal(acceptState, 'Ошибка оформления материала')
    useSuccessModal(acceptState, 'Материал успешно оформлен')

    return (
        <Button
            size={'small'}
            icon={<CheckOutlined />}
            color='green'
            variant={'outlined'}
            title={'Принять заказ'}
            onClick={onClick}
            loading={acceptState.isLoading}
        />
    )
}

export default Accept
